// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AppleFilledSvg from "@ant-design/icons-svg/es/asn/AppleFilled";
import AntdIcon from '../components/AntdIcon';

var AppleFilled = function AppleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AppleFilledSvg
  }));
};

AppleFilled.displayName = 'AppleFilled';
export default React.forwardRef(AppleFilled);